import React from 'react'
import '../../styles/Diagnostic/DiagnosticCarrez.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticCarrezSection2 from '../../assets/diagnostic/diagnostic-carrez-section2.jpg'
import diagnosticCarrezSection3 from '../../assets/diagnostic/diagnostic-carrez-section3.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticCarrez() {

    const section4Accordion1Data = [
        {
            title: "Sécurité Juridique",
            text: "Une déclaration incorrecte de la surface peut entraîner l’annulation de la vente ou une réduction du prix de vente. "
        }, {
            title: "Transparence",
            text: "Fournir une mesure précise de la superficie habitable renforce la confiance entre vendeur et acheteur, facilitant la conclusion de la vente."
        }, {
            title: "Valorisation du Bien",
            text: "Une mesure précise et certifiée peut valoriser votre bien en attestant de sa véritable superficie."
        }
    ]

    const section4Accordion2Data = [
        {
            title: " Expertise de qualité ",
            text: "Nos diagnostiqueurs sont formés pour vous assurer un service conforme aux normes en vigueur."
        }, {
            title: "Précision et Fiabilité",
            text: "Nous nous engageons à fournir des mesures exactes, vous offrant ainsi la tranquillité d’esprit pour votre transaction."
        }, {
            title: "Accompagnement Personnalisé",
            text: "Nous vous proposons un service personnalisé, répondant à toutes vos questions et vous guidant à chaque étape du processus."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Loi Carrez - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Loi Carrez sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Loi Carrez - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Loi Carrez sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/loi-Carrez" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/loi-Carrez" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticCarrez'>
                    <div id='header'>
                        <div id='diagnosticCarrezHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Loi Carrez</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticCarrezSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticCarrezSection1Left'>
                                    <h1 className='sectionTitle'>Loi Carrez : À quoi sert-elle ?</h1>
                                    <div className='sectionText'>
                                        La Loi Carrez, adoptée en décembre 1996, vise à protéger les acquéreurs de lots de copropriété en leur garantissant une information transparente et précise sur la superficie privative du bien qu’ils envisagent d’acheter.
                                        Elle impose au vendeur l’obligation de définir la superficie de la partie privative du lot ou des lots composant le bien vendu dans tous les documents relatifs à la vente. L’objectif est de prévenir les différences significatives
                                        entre la surface annoncée et la surface réelle, qui pourraient influencer la décision d’achat.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticCarrezSection1Right'>
                                    <h1 className='sectionTitle'>Dans quels cas la loi Carrez est-elle nécessaire ?</h1>
                                    <div className='sectionText'>
                                        L’application de la Loi Carrez est obligatoire pour tout bien immobilier en copropriété dès lors que la superficie privative est supérieure à 8 m². Cela concerne généralement :
                                    </div>
                                    <ul>
                                        <li>Les appartements</li>
                                        <li>Les maisons en lotissement</li>
                                        <li>Les locaux commerciaux ou professionnels en copropriété</li>
                                    </ul>
                                    <div className='sectionText'>
                                        Il est important de noter que la Loi Carrez ne s’applique pas aux maisons individuelles non soumises au régime de la copropriété.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticCarrezSection2'>
                        <Col sm={6}>
                            <div id='diagnosticCarrezSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <h1 className='sectionTitle'>Comment calculer une superficie en loi Carrez ?</h1>
                                    <div className='sectionText'>
                                        Le calcul de la superficie loi Carrez doit exclure certaines parties du bien, comme:
                                    </div>
                                    <ul>
                                        <li>Les surfaces dont la hauteur sous plafond est inférieure à 1,80 mètre</li>
                                        <li>Les escaliers et montées</li>
                                        <li>Les emplacements de stationnement</li>
                                        <li>Les caves, sous-sols, combles non aménageables, garages, terrasses, balcons et jardins</li>
                                    </ul>
                                    <div className='sectionText'>
                                        Le calcul doit être effectué avec précision, en tenant compte de tous les critères énoncés par la loi. Compte tenu de la complexité de ces mesures, il est vivement recommandé de faire appel à un professionnel certifié pour réaliser cette évaluation.
                                    </div>
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticCarrezSection2Right'>
                                    <img src={diagnosticCarrezSection2} id='diagnosticCarrezSection2Image' alt='diagnostic-carrez-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticCarrezSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticCarrezSection3Left'>
                                    <img src={diagnosticCarrezSection3} id='diagnosticCarrezSection3Image' alt='diagnostic-carrez-section3' />
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticCarrezSection3Right'>
                                    <h1 className='sectionTitle'>Que se passe-t-il en cas de litige sur la superficie Carrez ?</h1>
                                    <div className='sectionText'>
                                        En cas de différence supérieure à 5 % entre la superficie déclarée et la superficie réelle
                                    </div>
                                    <div className='sectionText'>
                                        Évaluée après la vente, l’acheteur dispose d’un délai d’un an à compter de la signature de l’acte de vente pour intenter une action en justice. contre le vendeur. Si l’action est jugée recevable, le vendeur peut être
                                        contraint de procéder à une réduction proportionnellement du prix de vente, en fonction de la superficie manquante.
                                    </div>
                                    <div className='sectionText'>
                                        Il est donc crucial pour le vendeur de s’assurer de la précision de la mesure de la surface de son bien avant la mise en vente, afin d’éviter tout litige ultérieur. Faire appel à un expert comme E5M Diagnostics
                                        garantit la réalisation de cette mesure avec précision et expertise, minimisant ainsi le risque de litige post-vente.
                                    </div>
                                    <div className='sectionText'>
                                        La mesure Loi Carrez, du nom de la loi qui l’a instaurée, est un élément incontournable dans le processus de vente d’un bien immobilier en copropriété. Cette mesure vise à déterminer avec précision la superficie
                                        privative d’un lot ou d’une fraction de lot. E5M Diagnostics se présente comme votre partenaire de confiance pour effectuer cet audit crucial, garantissant ainsi transparence et sérénité lors de votre transaction
                                        immobilière. Voici une présentation détaillée de nos services d’audit Loi Carrez.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticCarrezSection4'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Optimisez votre transaction immobilière d'E5M Diagnostics</h1>
                            <div className='sectionText'>
                                Lors de la vente d’un bien en copropriété, la loi impose la mention de la superficie privative, selon les dispositions de la Loi Carrez, dans tout acte de vente. Cette obligation vise à protéger l’acheteur contre les éventuelles erreurs
                                de surface qui pourraient affecter la valeur du bien.
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticCarrezSection5'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticCarrezSection5Left'>
                                    <h1 className='sectionTitle'>Pourquoi la loi Carrez est-elle essentielle ?</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticCarrezSection5Right'>
                                    <h1 className='sectionTitle'>Pourquoi choisir E5M Diagnostics ?</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticCarrez'>
                    <div id='header'>
                        <div id='diagnosticCarrezHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Loi Carrez</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticCarrezSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Loi Carrez : À quoi sert-elle ?</h1>
                            <div className='sectionTextMobile'>
                                La Loi Carrez, adoptée en décembre 1996, vise à protéger les acquéreurs de lots de copropriété en leur garantissant une information transparente et précise sur la superficie privative du bien qu’ils envisagent d’acheter.
                                Elle impose au vendeur l’obligation de définir la superficie de la partie privative du lot ou des lots composant le bien vendu dans tous les documents relatifs à la vente. L’objectif est de prévenir les différences significatives
                                entre la surface annoncée et la surface réelle, qui pourraient influencer la décision d’achat.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Dans quels cas la loi Carrez est-elle nécessaire ?</h1>
                            <div className='sectionTextMobile'>
                                L’application de la Loi Carrez est obligatoire pour tout bien immobilier en copropriété dès lors que la superficie privative est supérieure à 8 m². Cela concerne généralement :
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>Les appartements</li>
                                    <li>Les maisons en lotissement</li>
                                    <li>Les locaux commerciaux ou professionnels en copropriété</li>
                                </ul>
                            </div>
                            <div className='sectionTextMobile'>
                                Il est important de noter que la Loi Carrez ne s’applique pas aux maisons individuelles non soumises au régime de la copropriété.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticCarrezSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Comment calculer une superficie en loi Carrez ?</h1>
                            <div className='sectionTextMobile'>
                                Le calcul de la superficie loi Carrez doit exclure certaines parties du bien, comme:
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>Les surfaces dont la hauteur sous plafond est inférieure à 1,80 mètre</li>
                                    <li>Les escaliers et montées</li>
                                    <li>Les emplacements de stationnement</li>
                                    <li>Les caves, sous-sols, combles non aménageables, garages, terrasses, balcons et jardins</li>
                                </ul>
                            </div>
                            <div className='sectionTextMobile'>
                                Le calcul doit être effectué avec précision, en tenant compte de tous les critères énoncés par la loi. Compte tenu de la complexité de ces mesures, il est vivement recommandé de faire appel à un professionnel certifié pour réaliser cette évaluation.
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <img src={diagnosticCarrezSection2} id='diagnosticCarrezSection2ImageMobile' alt='diagnostic-carrez-section2' />
                        </Fade>
                    </div>
                    <div id='diagnosticCarrezSection3Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <img src={diagnosticCarrezSection3} id='diagnosticCarrezSection3ImageMobile' alt='diagnostic-carrez-section3' />
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Que se passe-t-il en cas de litige sur la superficie Carrez ?</h1>
                            <div className='sectionTextMobile'>
                                En cas de différence supérieure à 5 % entre la superficie déclarée et la superficie réelle
                            </div>
                            <div className='sectionTextMobile'>
                                Évaluée après la vente, l’acheteur dispose d’un délai d’un an à compter de la signature de l’acte de vente pour intenter une action en justice. contre le vendeur. Si l’action est jugée recevable, le vendeur peut être
                                contraint de procéder à une réduction proportionnellement du prix de vente, en fonction de la superficie manquante.
                            </div>
                            <div className='sectionTextMobile'>
                                Il est donc crucial pour le vendeur de s’assurer de la précision de la mesure de la surface de son bien avant la mise en vente, afin d’éviter tout litige ultérieur. Faire appel à un expert comme E5M Diagnostics
                                garantit la réalisation de cette mesure avec précision et expertise, minimisant ainsi le risque de litige post-vente.
                            </div>
                            <div className='sectionTextMobile'>
                                La mesure Loi Carrez, du nom de la loi qui l’a instaurée, est un élément incontournable dans le processus de vente d’un bien immobilier en copropriété. Cette mesure vise à déterminer avec précision la superficie
                                privative d’un lot ou d’une fraction de lot. E5M Diagnostics se présente comme votre partenaire de confiance pour effectuer cet audit crucial, garantissant ainsi transparence et sérénité lors de votre transaction
                                immobilière. Voici une présentation détaillée de nos services d’audit Loi Carrez.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticCarrezSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Optimisez votre transaction immobilière d'E5M Diagnostics</h1>
                            <div className='sectionTextMobile'>
                                Lors de la vente d’un bien en copropriété, la loi impose la mention de la superficie privative, selon les dispositions de la Loi Carrez, dans tout acte de vente. Cette obligation vise à protéger l’acheteur contre les éventuelles erreurs
                                de surface qui pourraient affecter la valeur du bien.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticCarrezSection5Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi la loi Carrez est-elle essentielle ?</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi choisir E5M Diagnostics ?</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion2Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>


    )

}

export default DiagnosticCarrez